/**
 * Which rail item a page belongs to on desktop (D-118). The rail holds Home, Clubs, Friends, Shop (and Admin); pages
 * one level down light up their parent, so Learn, You, Settings, Wallet, Notifications and the like never leave the
 * rail blank. Help (Settings › Help) lights the Help button at the rail's foot instead.
 */
// D-173: the rail matches the phone tab bar (D-165): Home, Tournaments, Clubs, Friends. Money pages light nothing.
export type RailSection = "home" | "tournaments" | "clubs" | "friends" | "shop" | "admin" | "help";

const RULES: { section: RailSection; test: (p: string) => boolean }[] = [
  { section: "help", test: (p) => p.startsWith("/you/settings/help") },
  { section: "admin", test: (p) => p.startsWith("/admin") },
  { section: "clubs", test: (p) => p.startsWith("/clubs") },
  { section: "friends", test: (p) => p.startsWith("/friends") || p.startsWith("/people") || p.startsWith("/players") || p.startsWith("/send") || p.startsWith("/transfer") || p.startsWith("/you/invite") },
  { section: "tournaments", test: (p) => p.startsWith("/tournaments") },
  // Everything reached from Home (the Wallet, Shop and your pages light nothing, like the phone).
  { section: "home", test: (p) => p === "/" || /^\/(setup|practice|learn|leaderboard|notifications|review)(\/|$)/.test(p) },
];

export function railSection(pathname: string): RailSection | null {
  return RULES.find((r) => r.test(pathname))?.section ?? null;
}
